import { ReactNode } from "react";

type Props = {
  children: ReactNode;
};

export default function TabletBody({ children }: Props) {
  return (
    <div className="relative left-[0.0625rem] w-[67.1875rem] h-[44.375rem] bg-no-repeat bg-cover rounded-4 overflow-hidden">
      {children}
    </div>
  );
}
